export const CACHE_KEY_LIST_PROTECTED_AREA = 'protectedAreas';
export const CACHE_KEY_LIST_PROTECTED_AREA_COUNT = 'protectedAreas-count';
export const CACHE_KEY_PROTECTED_AREA = 'protectedArea-one';
export const ROUTE_PATH_PROTECTED_AREA = '/configuration/protected-areas';
export const TRANSLATION_PREFIX_PROTECTED_AREA = 'protectedArea';
export const SECURITY_KEY_PROTECTED_AREA = 'PROTECTED_AREA';

